import type { FreelancerPersonalInformationPageLocales } from '../types';

const freelancerPersonalInformationPageLocales: FreelancerPersonalInformationPageLocales =
  {
    dialogueInstructionHeadline: 'Instructies',
    dialogueInstructionParagraph1:
      'We starten zo met het invullen van enkele persoonsgegevens zoals je naam, adres en telefoonnummer. Zodat wij en de opdrachtgevers precies weten wie je bent en hoe of waar we je kunnen bereiken. Daarnaast zijn de opdrachtgevers geïnteresseerd in de competenties die je mogelijk bezit.',
    dialogueInstructionParagraph2:
      'Mocht je bepaalde informatie nog niet hebben, dan kan je wel alvast verder met de andere onderdelen. De ontbrekende informatie kan je dan later alsnog uploaden. Ook kan je op een later moment verder gaan, mocht het je niet lukken om je aanmelding in één keer af te ronden. Doe dit wel binnen 30 dagen, want daarna verwijderen we je gegevens in verband met jouw privacy.',
    dialogueInstructionParagraph3:
      'Let op: je kan niet aan de slag als freelancer via Tadaah als we niet al je gegevens en benodigde documenten compleet hebben ontvangen.',
    dialogueInstructionParagraph4:
      'Daarnaast beantwoord je enkele vragen over Tadaah.',
    dialogueInstructionParagraph5:
      'Je wordt zo door ons aanmeldprocedure geleid. Regelmatig krijg je een overzicht van je voortgang in de aanmeldingsprocedure te zien.',
    dialogueInstructionRequiredInformationList: [
      'Je persoonlijke - en bedrijfsgegevens',
      'Je inschrijving bij de KVK',
      'Inschrijving in het Personenregister Kinderopvang (PRK)',
      'Bedrijfsaansprakelijkheidsverzekering',
      "Je behaalde diploma's en certificaten",
    ],
    formAddressError:
      'De combinatie van postcode, huisnummer en toevoeging is incorrect.',
    formCity: 'Woonplaats',
    formFirstName: 'Voornaam',
    formHouseNumber: 'Huisnummer',
    formHouseNumberAddition: 'Toevoeging',
    formLastName: 'Achternaam',
    formPhoneNumber: 'Telefoonnummer',
    formPostalCode: 'Postcode',
    formStreet: 'Straatnaam',
    needMoreInformation:
      'We hebben nog iets meer informatie over je nodig om de aanmelding compleet te maken.',
    personalInformationAdded: 'Persoonlijke Gegevens opgeslagen',
    profilePicture: 'Profielfoto',
    profilePictureAdded: 'Profielfoto geupload!',
    profileText: 'Profiel Text',
    profileTextPlaceholder:
      'Plaats hier een leuke, informele profiel tekst. (max 255 karakters)',
    title: 'Persoonlijke Gegevens',
    uploadProfilePicture: 'Profielfoto Uploaden',
  };

export default freelancerPersonalInformationPageLocales;
